// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"5d00547630d77edf","6356":"2018c38fc39216a4","8392":"6dcadcb831c88b90","8594":"1963fd6d1a91f02d","8709":"c16abb24b3c08b65","9651":"f380f1997f1f5ddd"}[chunkId] + ".js";
};